export const getBlogsData = (data) => (
    {
    type: 'BLOG_LOADED',
    payload : data
})